import { useMemo } from 'react';

// --- PURE CORE (no hooks) ---
/**
 * Renvoie la liste d’options "all" prête à l’usage.
 * Priorité: optionsOverride (si non vide) > fieldDef.parsedOptions > []
 */
export function getResolvedOptionsAll({ fieldDef, optionsOverride = null }) {
  const base =
    (Array.isArray(optionsOverride) && optionsOverride.length > 0
      ? optionsOverride
      : Array.isArray(fieldDef?.parsedOptions)
      ? fieldDef.parsedOptions
      : []) || [];
  return base;
}
export function getFieldListResolutionCore({
  fieldDef,
  singleValue = null,
  values = [],
  optionsOverride = null,
}) {
  const all =
    (Array.isArray(optionsOverride) && optionsOverride.length > 0
      ? optionsOverride
      : Array.isArray(fieldDef?.parsedOptions)
      ? fieldDef.parsedOptions
      : []) || [];

  const toOpt = (val) => {
    const key = val != null ? String(val) : '';
    if (!key) return null;
    const found = all.find((o) => String(o?.value) === key);
    return (
      found || {
        value: key,
        display: key,
        color: null,
        icon: null,
      }
    );
  };

  // single
  if (singleValue !== null && singleValue !== undefined) {
    const selected = toOpt(singleValue);
    return {
      selected, // Option|null
      selectedList: [], // Option[]
      all, // Option[]
      isSingle: true,
      isMultiple: false,
      isEmpty: !selected,
    };
  }

  // multi
  if (Array.isArray(values) && values.length > 0) {
    const selectedList = values.map(toOpt).filter(Boolean);
    return {
      selected: null,
      selectedList,
      all,
      isSingle: false,
      isMultiple: true,
      isEmpty: selectedList.length === 0,
    };
  }

  // empty
  return {
    selected: null,
    selectedList: [],
    all,
    isSingle: false,
    isMultiple: false,
    isEmpty: true,
  };
}

export function useFieldListResolver({
  fieldDef,
  singleValue = null,
  values = [],
  optionsOverride = null,
}) {
  const all = useMemo(() => {
    return (
      (Array.isArray(optionsOverride) && optionsOverride.length > 0
        ? optionsOverride
        : Array.isArray(fieldDef?.parsedOptions)
        ? fieldDef.parsedOptions
        : []) || []
    );
  }, [fieldDef?.parsedOptions, optionsOverride]);

  return useMemo(() => {
    return getFieldListResolutionCore({
      fieldDef, // only used for shape; core relies on `all` through params below
      singleValue,
      values,
      optionsOverride: all, // pass the precomputed list to avoid recompute
    });
  }, [all, singleValue, values, fieldDef]);
}

/**
 * Adaptateur mince :
 * - ne “va pas chercher” dans objectsDefList
 * - choisit la bonne source d’options (override > parsedOptions)
 * - mappe la/les valeur(s) vers options prêtes à l’affichage
 */
export function useFieldListResolverOLD({
  fieldDef,
  singleValue = null,
  values = [],
  optionsOverride = null, // ex. pour agréger contre fieldDef.optionsCat1/2
}) {
  return useMemo(() => {
    const all =
      (Array.isArray(optionsOverride) && optionsOverride.length > 0
        ? optionsOverride
        : Array.isArray(fieldDef?.parsedOptions)
        ? fieldDef.parsedOptions
        : []) || [];

    const toOpt = (val) => {
      const key = val != null ? String(val) : '';
      if (!key) return null;
      const found = all.find((o) => String(o?.value) === key);
      return (
        found || {
          value: key,
          display: key,
          color: null,
          icon: null,
        }
      );
    };

    // single
    if (singleValue !== null && singleValue !== undefined) {
      const selected = toOpt(singleValue);
      return {
        selected, // Option|null
        selectedList: [], // Option[]
        all,
        isSingle: true,
        isMultiple: false,
        isEmpty: !selected,
      };
    }

    // multi
    if (Array.isArray(values) && values.length > 0) {
      const selectedList = values.map(toOpt).filter(Boolean);
      return {
        selected: null,
        selectedList,
        all,
        isSingle: false,
        isMultiple: true,
        isEmpty: selectedList.length === 0,
      };
    }

    // rien
    return {
      selected: null,
      selectedList: [],
      all,
      isSingle: false,
      isMultiple: false,
      isEmpty: true,
    };
  }, [fieldDef, singleValue, values, optionsOverride]);
}
